var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export var CenterContent = function (_a) {
    var children = _a.children, style = _a.style, className = _a.className, vertical = _a.vertical, horizontal = _a.horizontal;
    var newStyle = __assign(__assign({}, style), { display: "flex", height: "100%", width: "100%" });
    if (vertical) {
        newStyle.alignItems = "center";
    }
    if (horizontal) {
        newStyle.justifyContent = "center";
    }
    return (_jsx("div", __assign({ style: newStyle, className: classNames(className) }, { children: children })));
};
